// ABOUTME: Feedback host mounted once in /warehouse: renders the redux-driven feedback modal.
// ABOUTME: Also renders a bottom-left balloon trigger that only appears while a sidepanel is open.

import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import FeedbackOutlinedIcon from "@mui/icons-material/FeedbackOutlined";
import { tokens } from "../../theme";
import { useGetSettingsQuery } from "../../newapi/global/generalApiSlice";
import { closeFeedback } from "../../newapi/global/settingsSlice";
import { captureAndOpenFeedback } from "../../utils/openFeedback";
import MFeedback from "./MFeedback";

const FeedbackWidget = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const feedbackOpen = useSelector((state) => state.settings.feedbackOpen);
    const feedbackScreenshot = useSelector((state) => state.settings.feedbackScreenshot);
    const openSidepanels = useSelector((state) => state.settings.openSidepanels);

    // useGetSettingsQuery takes the setting-group prefix; the request injects the active
    // warehouse_id header, so the returned rows are already scoped to the active warehouse.
    const { data: settings } = useGetSettingsQuery("feedback");

    const enabled = Array.isArray(settings)
        ? settings.some((s) => s.key === "feedback_enabled" && s.value === "true")
        : false;

    // The balloon is a fallback trigger: when a sidepanel is open the left sidebar
    // (with the feedback circle) sits behind the blurred backdrop, so we surface a
    // floating trigger above the backdrop instead.
    const showBalloon = enabled && openSidepanels > 0;

    return (
        <>
            {showBalloon && (
                <Box
                    data-feedback-widget="balloon"
                    onClick={() => captureAndOpenFeedback(dispatch, t)}
                    sx={{
                        position: "fixed",
                        bottom: 24,
                        left: 24,
                        zIndex: 1250,
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        color: "#fff",
                        background: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                        boxShadow: "0px 4px 12px rgba(0,0,0,0.25)",
                    }}
                >
                    <FeedbackOutlinedIcon />
                </Box>
            )}
            <MFeedback
                open={feedbackOpen}
                onClose={() => dispatch(closeFeedback())}
                initialScreenshot={feedbackScreenshot}
            />
        </>
    );
};

export default FeedbackWidget;
